import classnames from "classnames";
import React from "react";

import FormattedMessage from "@components/UI/FormattedMessage";

import { FlightType, State } from "./types";

export type Props = {
  flightType: FlightType;
  setState: React.Dispatch<React.SetStateAction<State>>;
  activeFilter: number;
  numberOfFlights: number;
};

const FilterBoxTabs = ({
  flightType,
  activeFilter,
  numberOfFlights,
  setState,
}: Props) => {
  const activateTab = (tab: number) => {
    setState((state) => ({ ...state, activeFilter: tab }));
  };

  if (flightType === "RETURN") {
    return (
      <div className="filter-box-tabs">
        <span
          role="button"
          id="filter-tab-time-0"
          onClick={() => activateTab(0)}
          className={classnames("filter-tab", {
            "filter-tab-active": activeFilter === 0,
          })}
        >
          <FormattedMessage id="Filters.wayThere" />
        </span>

        <span
          role="button"
          id="filter-tab-time-1"
          onClick={() => activateTab(1)}
          className={classnames("filter-tab", {
            "filter-tab-active": activeFilter === 1,
          })}
        >
          <FormattedMessage id="Filters.wayBack" />
        </span>
      </div>
    );
  }

  if (flightType === "MULTI") {
    return (
      <div className="filter-box-tabs">
        {[...Array(numberOfFlights)].map((_el, i) => (
          <span
            key={i}
            role="button"
            onClick={() => activateTab(i)}
            className={classnames("filter-tab", {
              "filter-tab-active": activeFilter === i,
            })}
          >
            {i + 1}
          </span>
        ))}
      </div>
    );
  }

  return null;
};

export default FilterBoxTabs;
